import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const PUBLI_TEMP_GATE_KEY = "publi_temp_gate";

function isGateOpen(): boolean {
  try {
    return sessionStorage.getItem(PUBLI_TEMP_GATE_KEY) === "1";
  } catch {
    return false;
  }
}

/**
 * Guard du module /publi-temp. Vérifie 2 choses :
 *  1. Le gate password a bien été ouvert (sessionStorage flag).
 *  2. L utilisateur a une dev session active (set par le login temp).
 *
 * Sinon → redirect vers /publi-temp/login. Si l utilisateur ferme l onglet,
 * sessionStorage est nettoyé → il devra ressaisir le mdp à la prochaine visite.
 */
export function TempPublishGuard() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  if (!isGateOpen() || !isAuthenticated) {
    return <Navigate to="/publi-temp/login" replace />;
  }

  return <Outlet />;
}
